'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = origin;
/*
 * @Author: edvardchen
 * @Date:   2017-03-14 15:05:30
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2018-06-01 11:15:15
 */

/**
 * 返回不同环境的 origin
 * @param  {String} env
 * @return {String}
 */
function origin(env) {
  switch (env) {
    case 'test':
      return 'http://news.sparta.html5.qq.com';
    default:
      return 'https://news.html5.qq.com';
  }
}